{
  "name": "digital-security-fe",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start:dev": "ng serve",
    "start:local": "ng serve --proxy-config proxy-local.conf.json",
    "build": "ng build",
    "build:dev": "ng build --configuration development",
    "lint": "ng lint",
    "postinstall": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.5",
    "@angular/cdk": "^19.2.8",
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/forms": "^19.2.0",
    "@angular/google-maps": "^19.2.8",
    "@angular/material": "^19.2.8",
    "@angular/material-date-fns-adapter": "^19.2.8",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@angular/service-worker": "^19.2.0",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@ngrx/component-store": "^19.1.0",
    "@ngxs/storage-plugin": "^19.0.0",
    "@ngxs/store": "^19.0.0",
    "date-fns": "^4.1.0",
    "echarts": "^5.6.0",
    "mediasoup-client": "^3.9.5",
    "ngx-echarts": "^19.0.0",
    "rxjs": "~7.8.0",
    "socket.io-client": "^4.8.1",
    "ts-morph": "^21.0.1",
    "tslib": "^2.3.0",
    "ua-parser-js": "^2.0.9",
    "webm-inspector": "^1.0.1",
    "webm-muxer": "^5.1.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.6",
    "@angular/build": "^19.2.6",
    "@angular/cli": "^19.2.6",
    "@angular/compiler-cli": "^19.2.0",
    "@ngx-env/builder": "^19.1.0",
    "angular-eslint": "^19.3.0",
    "eslint": "^9.24.0",
    "eslint-config-prettier": "^10.1.1",
    "eslint-import-resolver-typescript": "^4.3.2",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prettier": "^5.2.6",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "husky": "^9.1.7",
    "lint-staged": "^15.5.0",
    "prettier": "^3.5.3",
    "prettier-eslint": "^16.3.0",
    "typescript": "~5.7.2",
    "typescript-eslint": "^8.29.1"
  },
  "lint-staged": {
    "*.ts": [
      "prettier --write",
      "eslint --fix"
    ],
    "*.html": [
      "prettier --write",
      "eslint --fix"
    ]
  },
  "packageManager": "yarn@4.5.3"
}
